import { FeatureFlagVariationValue, isClientSide, useFeatureFlag } from '@moda/portal-stanchions';

type Config = { default: number; google?: number };

const DEFAULT_CONFIG: Config = { default: 3, google: 3 };

const isValidConfig = (treatment: FeatureFlagVariationValue): treatment is Config =>
  typeof treatment === 'object' &&
  treatment != null &&
  'default' in treatment &&
  typeof treatment.default === 'number';

export const useEmailSignupPagesToViewBeforeModalShows = () => {
  const config = useFeatureFlag('email-signup-modal', [
    { default: DEFAULT_CONFIG },
    { getFromTreatment: treatment => (isValidConfig(treatment) ? treatment : DEFAULT_CONFIG) }
  ]);

  return isClientSide() && document.referrer.includes('google')
    ? config.google ?? config.default
    : config.default;
};
